import {Injectable} from '@angular/core';
import { Router } from '@angular/router';
import {AbstractFncGroupGuard} from './AbstractFncGroupGuard';
import {AuthService} from '../../auth/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FncGroup} from '../../auth/FncGroup';

@Injectable({
  providedIn: 'root'
})
export class IsItSupportGuard extends AbstractFncGroupGuard  {

  constructor(
    authService: AuthService,
    snackBar: MatSnackBar,
    router: Router,
  ) {
    super([FncGroup.IT_SUPPORT], authService, snackBar, router);
  }

}
